import type { Tables } from "@/integrations/supabase/types";
import type { CustomerCategory } from "@/hooks/useCustomerCategories";

export type Customer = Tables<"customers">;

// Type for booking rows with joined courts in stats queries
export type BookingWithStatus = {
  status: string;
  price_total: number | null;
  courts: { hall_id: string; halls: { organization_id: string } } | null;
};

// Type for customer booking history with joined courts
export type CustomerBooking = Tables<"bookings"> & {
  courts: { name: string; hall_id: string; halls: { name: string; organization_id: string } } | null;
};

// Type for team with league join
export type TeamWithLeague = Tables<"teams"> & {
  leagues: { name: string } | null;
};

// Type for group member with training group join
export type GroupMemberWithGroup = {
  group_id: string;
  status: string;
  training_groups: { name: string; color: string | null; seasons: { name: string } | null } | null;
};

// No-show record type (table may not be in generated types)
export interface NoShowRecord {
  id: string;
  user_id: string;
  organization_id: string;
  booking_id: string | null;
  recorded_at: string;
  forgiven: boolean;
  forgiven_at: string | null;
  bookings: { start_time: string; courts: { name: string } | null } | null;
}

export const emptyForm = {
  email: "",
  full_name: "",
  phone: "",
  level: 1,
  preferred_hand: "",
  player_type: "",
  notes: "",
  category_id: "",
};

export type CustomerForm = typeof emptyForm;

export type { CustomerCategory };
